import { useSelect } from '@wordpress/data';

import SinglePreset from "../components-presets/single-doc-presets/SinglePreset";

import PreviewChoose from "../PreviewChoose";

export default function  SingleDoc({attributes, setAttributes, docPosts }){

    const {
        docSinglePreset,
        parentTitle,
        docId,
        sectionsNumber,
        articlesNumber,
        parent_docs_order,
        } = attributes

    // sections title post
    const docSections = useSelect((select) => {
        return select('core').getEntityRecords('postType', 'docs', {
            per_page: sectionsNumber,
            order: parent_docs_order,
            orderby : 'menu_order',
            parent: docId,
            status: ['publish', 'private']
        });
    }, [docId, sectionsNumber, parent_docs_order]);
    
    let docPostsTitle =[];

    if (docPosts && docPosts.length > 0) {
        docPostsTitle = docPosts.map(post => ({
            label: post.title.rendered,
            value: post.id
        }));
    }

    let presetTemplate = <SinglePreset docSections={ docSections } attributes={attributes}  articlesNumber={articlesNumber}  />;
    
    return (
        <>
            <PreviewChoose attributes={ attributes } setAttributes={ setAttributes }  />
            {presetTemplate}
        </>
    );
}